import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../../box';
import { EmptyState } from '../../empty-state';
export const NoRowsOverlay = (props) => {
    if (!props.children) {
        return null;
    }
    return (_jsx(FlexBox, { padding: 3, width: "100%", height: "100%", children: _jsx(EmptyState, { ...props }) }));
};
